// extracted by mini-css-extract-plugin
export var text = "_1a-0";